module.exports = __webpack_public_path__ + "static/img/son6.da75c951.png";